import { useMemo } from "react";
import {
  Chart as ChartJS, ArcElement, Tooltip, Legend,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

export function DeliveryChart({ orders, height = "250px" }) {
  const { delivery, collect } = useMemo(() => {
    const paid = orders.filter(o => o.paid);
    return {
      delivery: paid.filter(o => o.delivery_method !== "collect").length,
      collect:  paid.filter(o => o.delivery_method === "collect").length,
    };
  }, [orders]);

  const total = delivery + collect;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "65%",
    plugins: {
      legend: {
        position: "bottom",
        labels: { font: { size: 11 }, usePointStyle: true, pointStyleWidth: 8, padding: 16, color: "#718096" },
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,.82)",
        titleFont: { size: 12, weight: "600" },
        bodyFont: { size: 11 },
        padding: 10,
        cornerRadius: 8,
        callbacks: {
          label: ctx => {
            const pct = total > 0 ? ((ctx.raw / total) * 100).toFixed(1) : 0;
            return ` ${ctx.label}: ${ctx.raw} pedido${ctx.raw !== 1 ? "s" : ""} (${pct}%)`;
          },
        },
      },
    },
  };

  const data = {
    labels: ["Entrega", "Retirada"],
    datasets: [
      {
        data: [delivery, collect],
        backgroundColor: ["rgba(41,128,185,.8)", "rgba(39,174,96,.8)"],
        borderColor: ["#2980b9", "#27ae60"],
        borderWidth: 2,
        hoverOffset: 6,
      },
    ],
  };

  return (
    <div style={{ height, width: "100%", position: "relative" }}>
      <Doughnut options={options} data={data} />
    </div>
  );
}
